import qs from 'query-string'
import { useContext, useEffect } from 'react'
import { useLocation } from 'react-router'

import { useModalState } from 'hooks'

import { useNavigate } from 'features/i18n/router'

import IncomingCallNotification from './components/IncomingCallNotification'
import PushNotificationContext from './PushNotificationContext'

import './style.scss'

const PushNotification = () => {
  const navigate = useNavigate()
  const callNotification = useModalState()
  const { message } = useContext(PushNotificationContext)
  const location = useLocation()

  /*{"message":"Rule breaker（Aon） is inviting group call📞","user_icon":"https://f002.backblazeb2.com/file/yay-space-stg/uploads/user/11/profile_icon/thumb_gomimushi.png","user_nickname":"Rule breaker（Aon）","conference_call_id":13211,"type":"conference_call","post_id":77610973,"title":"📣Invited for group call📣","notification_sound":"notif.caf"}*/
  const executeMessage = (message) => {
    if (typeof message === 'undefined') return
    // 1-1 call
    if (
      message.type === 'invite_call' ||
      message.type === 'invite_video_call'
    ) {
      callNotification.open({
        ...message,
        conference_call_id: message.room_id,
      })
    }
  }

  useEffect(() => {
    executeMessage(message)
  }, [message])

  useEffect(() => {
    const { nd, ...queryObject } = qs.parse(location.search)
    if (typeof nd !== 'undefined') {
      // decode message
      try {
        executeMessage(JSON.parse(decodeURIComponent(nd as string)))

        let query = qs.stringify(queryObject || {})
        navigate(`${location.pathname}${query !== '' ? `?${query}` : ''}`, {
          replace: true,
        })
      } catch (e) {
        console.error('cannot decode notification message', e)
      }
    }
  }, [location.search])

  return (
    <IncomingCallNotification
      isActive={callNotification.isActive}
      onClose={callNotification.close}
      callNotification={callNotification?.data}
    />
  )
}

export default PushNotification
